class mariSmithTutorials  implements ng.IComponentController {
}

angular.module('animatronApp.wave.mariSmithTutorials', []).component('mariSmithTutorials', {
    controller: mariSmithTutorials,
    templateUrl: require('wave/mari-smith-tutorials.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/wave/mariSmithTutorials.ts